import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'
// import Vuetify from 'vuetify/lib'
import vuetify from './plugins/vuetify'

import store from '@/store'
// import App from './App.vue'
import CompositeProduct from 'Components/CompositeProduct'
import MessageSelector from 'Components/MessageSelector'
import PurchaseConfirmation from 'Components/PurchaseConfirmation'

import SearchForm from 'Assets/js/SearchForm'
import Select2 from 'Assets/js/Select2'
import WooCheckout from 'Assets/js/WooCheckout'

import 'Plugins'

import 'jquery-steps/build/jquery.steps'
// import 'jquery-steps.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// import 'Assets/scss/main.scss'
window.jQuery(document).ready(function () {
  SearchForm.init()
  Select2.init()
  WooCheckout.init()
})

console.log('process.env.NODE_ENV', process.env.NODE_ENV)
// const Vue = process.env.NODE_ENV === 'production' ? window.Vue : VuePack
Vue.config.productionTip = false

// Vue.use(BootstrapVue)
// Vue.use(Vuetify)

/*--- Dom Ready ---*/
;(function () {
  if (document.getElementById('bn-composite-product')) {
    const dataProduct = document.getElementById('bn-composite-product').dataset
      .product
    // console.log('dataProducts', dataProduct)

    new Vue({
      store,
      vuetify,
      render: (h) => {
        Vue.prototype.$dataProduct = dataProduct
        return h(CompositeProduct)
      },
      components: { CompositeProduct },
    }).$mount('#bn-composite-product')
  }

  function initMessageSelector() {
    if (document.getElementById('bn-message-selector')) {
      if (!document.getElementById('bn-message-selector-mount')) {
        const elMount = window.jQuery('<div>', {
          id: 'bn-message-selector-mount',
        })

        window.jQuery('#bn-message-selector').html(elMount)
      }

      const dataMessages = document.getElementById('bn-message-selector')
        .dataset.messages

      new Vue({
        store,
        vuetify,
        render: (h) => {
          Vue.prototype.$dataMessages = dataMessages
          return h(MessageSelector)
        },
        components: { MessageSelector },
      }).$mount('#bn-message-selector #bn-message-selector-mount')
    }
  }

  function initPurchaseConfirmation() {
    if (document.getElementById('bn-purchase-confirmation')) {
      new Vue({
        store,
        vuetify,
        render: (h) => {
          return h(PurchaseConfirmation)
        },
        components: { PurchaseConfirmation },
      }).$mount('#bn-purchase-confirmation')
    }
  }

  window
    .jQuery('form.checkout .validate-required :input')
    .attr('required', 'required')
  window.jQuery('form.checkout .validate-email .input-text').addClass('email')
  const stepsWizard = window.jQuery('#wizard').steps({
    headerTag: 'h3',
    labels: {
      next: 'Continuar',
      previous: 'Volver',
    },
    onInit: function () {
      // (event, currentIndex)
      setTimeout(() => {
        window.jQuery.extend(window.jQuery.validator.messages, {
          required: 'Este campo es obligatorio.',
          remote: 'Por favor, rellena este campo.',
          email: 'Por favor, escribe una dirección de correo válida',
          url: 'Por favor, escribe una URL válida.',
          date: 'Por favor, escribe una fecha válida.',
          dateISO: 'Por favor, escribe una fecha (ISO) válida.',
          number: 'Por favor, escribe un número entero válido.',
          digits: 'Por favor, escribe sólo dígitos.',
          creditcard: 'Por favor, escribe un número de tarjeta válido.',
          equalTo: 'Por favor, escribe el mismo valor de nuevo.',
          accept: 'Por favor, escribe un valor con una extensión aceptada.',
          maxlength: window.jQuery.validator.format(
            'Por favor, no escribas más de {0} caracteres.'
          ),
          minlength: window.jQuery.validator.format(
            'Por favor, no escribas menos de {0} caracteres.'
          ),
          rangelength: window.jQuery.validator.format(
            'Por favor, escribe un valor entre {0} y {1} caracteres.'
          ),
          range: window.jQuery.validator.format(
            'Por favor, escribe un valor entre {0} y {1}.'
          ),
          max: window.jQuery.validator.format(
            'Por favor, escribe un valor menor o igual a {0}.'
          ),
          min: window.jQuery.validator.format(
            'Por favor, escribe un valor mayor o igual a {0}.'
          ),
        })
      })
    },
    onStepChanging: function (event, currentIndex, newIndex) {
      console.log('steps', event, currentIndex, newIndex)
      const itsComingBack = currentIndex > newIndex

      // return true
      let form_valid = false

      if (window.jQuery('form.checkout').valid() || itsComingBack) {
        form_valid = true
      }

      if (newIndex == 2 && form_valid) {
        initMessageSelector()
      }

      if (newIndex == 4 && form_valid) {
        initPurchaseConfirmation()
      }

      return form_valid
    },
    /* onStepChanging: function () {
      let form_valid = false

      if (window.jQuery('form.checkout').valid()) {
        form_valid = true
      }

      return form_valid
    }, */
  })

  window.jQuery('.actions > ul li:last a').addClass('finish-btn')
  window.jQuery('.finish-btn').on('click', function () {
    window.jQuery('#place_order').trigger('click')
  })

  // console.log(stepsWizard)
  for (var i = 0; i < 0; i++) {
    stepsWizard.steps('next')
  }
})()
